import * as PortOne from '@portone/browser-sdk/v2'

import type { components } from '../constants/schema'

import RootStore from '../store/root'

export async function requestIdentityVerification(redirectUrl: string) {
  localStorage.setItem('isVerification', 'true')
  const getIdentityVerificationId = await new RootStore().identityStore.getIdentityVerificationId()

  if (!getIdentityVerificationId) return false

  return await PortOne.requestIdentityVerification({
    redirectUrl,
    storeId: process.env.REACT_APP_ARTIPIO_PORTONE_STORE_ID as string,
    identityVerificationId: getIdentityVerificationId.identityVerificationId,
    channelKey: process.env.REACT_APP_ARTIPIO_PORTONE_CHANNEL_KEY,
    windowType: {
      pc: 'POPUP',
      mobile: 'REDIRECTION',
    },
  })
}

export function convertIdentityVerificationResult(query: string): components['schemas']['ReqQueryIdentication'] {
  let result = {}
  query.split('&').forEach((data) => {
    const [key, value] = data.split('=')
    result = { ...result, [key]: value }
  })
  return result as components['schemas']['ReqQueryIdentication']
}

export async function requestIdentify(data: components['schemas']['ReqQueryIdentication']) {
  localStorage.removeItem('isVerification')
  return await new RootStore().identityStore.identify(data)
}
